import React from 'react';
import { useParams } from 'react-router-dom';
import { isLocalePrefix } from 'utils/localePath';
import RequireAuth from '../HCOs/RequireAuth';
import AdminIntranetLayout from 'layouts/adminIntranetLayout';
import NotFound from 'pages/notfound';

const LocaleIntranetLayout = () => {
  const { locale } = useParams();

  if (!isLocalePrefix(locale)) {
    return <NotFound />;
  }

  return (
    <RequireAuth>
      <AdminIntranetLayout />
    </RequireAuth>
  );
};

export default LocaleIntranetLayout;
